"use strict";

const bowser = require('bowser');

window.bowser = bowser;

['mac', 'windows', 'ios', 'firefox', 'android'].forEach(function eachOS(os, i) {
    Modernizr.addTest(os, bowser[os]);
});

var browserName = bowser.name
    .toLowerCase()
    .replace(/\s/gi, '-')
    .replace(/internet[-\s]explorer/gi, 'ie')
    .replace(/microsoft[-\s]edge/gi, 'edge')
    .replace(/Firefox/gi, 'firefox')
;

Modernizr
    .addTest('firefox', 'firefox' === browserName)
    .addTest('safari', 'safari' === browserName)
    .addTest('ie', 'ie' === browserName)
    .addTest('edge', 'edge' === browserName)
    .addTest('mobile', !!bowser.mobile || !!bowser.tablet)
    .addTest('ipad', /ipad/gi.test(navigator.userAgent))
    .addTest('iphone', /iphone/gi.test(navigator.userAgent))
    .addTest(browserName, true)
    .addTest('ie6', 'ie' === browserName && 6 === parseInt(bowser.version))
    .addTest('ie11', 'ie' === browserName && 11 === parseInt(bowser.version))
;

var isOldBrowser = (function (m) {
    return !m.svg || !m.flexbox || !m.csstransforms;
})(Modernizr);


Modernizr.addTest('old-browser', isOldBrowser);

if (isOldBrowser || Modernizr.ie && [5, 6, 7, 8, 9].indexOf(parseInt(bowser.version)) >= 0) {
    Modernizr.addTest('oldbrowser', true);
}



// WEBPACK FOOTER //
// ./js/main/package/browser-tests.js